import type { RefObject } from 'react';
import { cn } from '@/shared/lib/cn';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from '@/shared/ui';
import styles from './Tour.module.css';

interface TourCardProps {
  popupRef: RefObject<HTMLDivElement>;
  nextRef: RefObject<HTMLButtonElement>;
  modal: boolean;
  sheet: boolean;
  anchored: boolean;
  pass: boolean;
  counter: string;
  title: string;
  body: string;
  nextLabel: string;
  onNext: () => void;
  busy?: boolean;
  onBack?: () => void;
  onSkip?: () => void;
  onClose: () => void;
}

export function TourCard({
  popupRef,
  nextRef,
  modal,
  sheet,
  anchored,
  pass,
  counter,
  title,
  body,
  nextLabel,
  onNext,
  busy = false,
  onBack,
  onSkip,
  onClose,
}: TourCardProps) {
  return (
    <Dialog
      open
      modal={modal}
      onOpenChange={(open, details) => {
        if (!open && details.reason !== 'outside-press') onClose();
      }}
    >
      <DialogContent
        ref={popupRef}
        className={cn(styles.window, sheet && styles.sheet, anchored && styles.anchored)}
        backdropClassName={cn(styles.backdrop, pass && styles.pass)}
        initialFocus={nextRef}
        onKeyDown={(e) => {
          if (e.key === 'ArrowRight' && !busy) onNext();
          else if (e.key === 'ArrowLeft') onBack?.();
        }}
      >
        <span className={styles.counter}>{counter}</span>
        <div className={styles.text} aria-live="polite">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className={styles.body}>{body}</DialogDescription>
        </div>
        <DialogFooter className={styles.footer}>
          {onSkip && (
            <Button variant="ghost" className={styles.skip} onClick={onSkip}>
              Пропустить
            </Button>
          )}
          {onBack && (
            <Button variant="secondary" onClick={onBack}>
              Назад
            </Button>
          )}
          <Button ref={nextRef} onClick={onNext} disabled={busy}>
            {nextLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
